import Worker from 'workerize-loader?inline!./live-worker/LiveWorker';
/**
 * Web Worker for live matches
 */
export const LiveWorker = new Worker(Worker);